module.exports = __webpack_public_path__ + "static/AL-3fa30b1fefe619aa3ea2cb78d0cb66d7.svg";